// extracted by mini-css-extract-plugin
export default {"imageContainer":"JobCard_imageContainer__Lppod","contentsRow":"JobCard_contentsRow__WVHD9"};